const RESOURCE_PROPERTIES = Object.freeze({
  dashboard: {
    section: "dashboard",
    field: "background",
    image: "--theme-dashboard-image",
    position: "--theme-dashboard-position",
  },
});

const LEGACY_PROPERTIES = Object.freeze([
  "--theme-header-decoration-image",
  "--theme-header-decoration-position",
]);

const SAFE_POSITIONS = new Set([
  "center",
  "center top",
  "center bottom",
  "left top",
  "left bottom",
  "right top",
  "right bottom",
]);

function safeUrl(value) {
  if (typeof value !== "string") return "";
  if (value.startsWith("/")) return value;
  try {
    const parsed = new URL(value, window.location.origin);
    return ["http:", "https:"].includes(parsed.protocol) ? value : "";
  } catch (error) {
    return "";
  }
}

function cssUrl(url) {
  return `url("${url.replace(/["\\\n\r()]/g, "")}")`;
}

function normalizeUrls(value, serverUrl) {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeUrls(item, serverUrl));
  }
  if (!value || typeof value !== "object") return value;
  return Object.keys(value).reduce((result, key) => {
    const child = value[key];
    if (key === "url" && typeof child === "string") {
      try {
        result[key] = new URL(child, serverUrl).href;
      } catch (error) {
        result[key] = "";
      }
    } else {
      result[key] = normalizeUrls(child, serverUrl);
    }
    return result;
  }, {});
}

function reset(root = document.documentElement) {
  Object.values(RESOURCE_PROPERTIES).forEach((resource) => {
    root.style.removeProperty(resource.image);
    root.style.removeProperty(resource.position);
  });
  LEGACY_PROPERTIES.forEach((property) => root.style.removeProperty(property));
}

function apply(config = {}, root = document.documentElement) {
  reset(root);
  Object.values(RESOURCE_PROPERTIES).forEach((resource) => {
    const value = config?.[resource.section]?.[resource.field];
    const url = safeUrl(value?.url);
    if (!url) return;
    root.style.setProperty(resource.image, cssUrl(url));
    root.style.setProperty(
      resource.position,
      SAFE_POSITIONS.has(value.position) ? value.position : "center"
    );
  });
}

export default { apply, reset, safeUrl, normalizeUrls };
